// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"144":"8bf635e3","243":"e01dddc1","279":"8cac5109","349":"6a79f301","465":"1a25ee1b","552":"ba2988fa","554":"f3e0a47f","607":"5fdec7cf","743":"08c7d7bf","780":"cad93af0","799":"8f3cb1b6","826":"f8586c19","906":"2911f3c3"}[chunkId] + ".js";
};